import { PERMISSIONS } from '@/libs/acl/permissions'

export default [
  {
    path: '/apps/inventory/inventory-snapshot',
    name: 'route-inventory-snapshot',
    component: () => import('@/views/apps/inventory-snapshot/InventorySnapshot.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_INVENTORY_SNAPSHOT,
      action: 'read',
      pageTitle: 'Inventory Snapshot',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Inventory Snapshot',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/inventory/:itemAction',
    name: 'prep-inventory',
    component: () => import('@/views/apps/inventory/Inventory.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MANAGE_INVENTORY,
      action: 'read',
      pageTitle: 'Amazon FBA Prep',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Amazon FBA Prep',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/inventory/:itemAction',
    name: 'wfs-inventory',
    component: () => import('@/views/apps/inventory/Inventory.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MANAGE_INVENTORY,
      action: 'read',
      pageTitle: 'Walmart WFS Prep',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Walmart WFS Prep',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/inventory/:itemAction',
    name: 'fbm-inventory',
    component: () => import('@/views/apps/inventory/Inventory.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MANAGE_INVENTORY,
      action: 'read',
      pageTitle: 'Merchant Fulfillment',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Merchant Fulfillment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/inventory/:itemAction',
    name: 'storage-inventory',
    component: () => import('@/views/apps/inventory/Inventory.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MANAGE_INVENTORY,
      action: 'read',
      pageTitle: 'Storage Inventory',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Storage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/inbound/receive-batch/account-select',
    name: 'route-receive-batch-account-select',
    component: () => import('@/views/apps/inbound/receive-batch/AccountSelect.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_RECEIVE_INVENTORY,
      action: 'read',
      pageTitle: 'Receive Batch Account Select',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inbound',
        },
        {
          text: 'Account Select',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/inbound/receive-batch/:accountNo/:companyId/:storeId?/:planId?/:action?',
    name: 'route-receive-batch',
    component: () => import('@/views/apps/inbound/receive-batch/ReceiveBatch.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_RECEIVE_INVENTORY,
      action: 'read',
      pageTitle: 'Receive Inventory',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Account Select',
          to: '/apps/inbound/receive-batch/account-select',
        },
        {
          text: 'Receive Inventory',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/inventory/:inventoryType',
    name: 'amazon-inventory',
    component: () => import('@/views/apps/inventory/view/AmazonInventory.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_MANAGE_INVENTORY,
      action: 'read',
      pageTitle: 'Amazon Inventory',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Amazon',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/product/products',
    name: 'route-products',
    component: () => import('@/views/apps/product/products/Products.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_PRODUCT_CATALOG,
      action: 'read',
      pageTitle: 'Product Catalog',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Product Catalog',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/product/products/create-bundle',
    name: 'route-create-bundle',
    component: () => import('@/views/apps/product/products/components/CreateBundleProduct.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_PRODUCT_CATALOG,
      action: 'read',
      pageTitle: 'Create Bundle',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Product Catalog',
          to: '/apps/product/products',
        },
        {
          text: 'Create Bundle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/reports/dispositions',
    name: 'dispositions',
    component: () => import('@/views/apps/reports/amazon-reports/Removals.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_DISPOSITIONS,
      action: 'read',
      pageTitle: 'Dispositions',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Inventory',
        },
        {
          text: 'Dispositions',
          active: true,
        },
      ],
    },
  },
]
